import './synchro-view.scss'

import { faCalendarAlt, faCaretDown, faCaretRight, faCircleNotch, faStopwatch, faSyncAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import { DataSynchronisationStatus } from '@skinsoft/types';
import { SynchroDownHandler } from '@skinsoft/classes-interfaces-definition';
import { formatDateFromNow, formatDuration } from '@skinsoft/utils';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { OnlineStatusIndicator } from '@skinsoft/offline-mode/src/components/online-status-indicator';

@Component({
    components: {
        sOnlineStatusIndicator: OnlineStatusIndicator
    },
    props: ['synchDownHandler', 'title'],
    template: require('./synchro-view.html')
})
export class SynchroView extends ReactiveVue {

    public synchDownHandler: SynchroDownHandler
    public title: string;

    private syncing: boolean = false;

    // Icons
    private syncIcon = faSyncAlt;
    private durationIcon = faStopwatch;
    private lastDateIcon = faCalendarAlt;
    private loadingIcon = faCircleNotch;
    private crossIcon = faTimes;
    private rightArrow = faCaretRight;
    private downArrow = faCaretDown;

    private progressBarVariant: string = "success";
    private collapsed: boolean = true;

    public mounted() {
        switch (this.synchDownHandler.getLastSyncStats()?.lastSynchroStatus) {
            case DataSynchronisationStatus.SUCCESS:
                this.progressBarVariant = "success"
                break;
            default:
                this.progressBarVariant = "danger"
                break;
        }

        this.syncing = this.synchDownHandler.isSyncing();
    }

    private synchronize() {
        const synchroStats = this.synchDownHandler.getLastSyncStats()
        if (synchroStats) {
            synchroStats.lastSynchroStatus = DataSynchronisationStatus.SUCCESS;
        }
        this.progressBarVariant = "success";
        this.syncing = true;
        this.synchDownHandler.synchronize(0, true, true);
    }

    private abortSynchronisation() {
        this.synchDownHandler.abortSynchronisation();
        this.progressBarVariant = "danger";
        this.syncing = false;
    }

    private get synchroNbMax() {
        return this.synchDownHandler.getLastSyncStats()?.maxNbToSynchronize;
    }

    private get synchroNbCurrent() {
        return this.synchDownHandler.getLastSyncStats()?.currentNbSychronized;
    }

    private get progressBarValue(): number | undefined {
        // to fix a display bug of b-progress-bar when max is 0
        if(this.synchroNbMax === 0 && this.synchroNbCurrent === 0) {
            return 1
        }

        return this.synchroNbCurrent
    }

    private get progressBarMax(): number | undefined {
        // to fix a display bug of b-progress-bar when max is 0
        if(this.synchroNbMax === 0 && this.synchroNbCurrent === 0) {
            return 1
        }

        return this.synchroNbMax
    }

    private get lastSynchroDuration() {
        if (this.synchDownHandler.getLastSyncStats()?.lastSynchroDuration) {
            return formatDuration(this.synchDownHandler.getLastSyncStats()?.lastSynchroDuration,
                this.$t('time.minutes'), this.$t('time.seconds'))
        }
    }

    private get lastSynchroDate() {
        return formatDateFromNow(
            this.synchDownHandler.getLastSyncStats()?.lastSynchroDate, 
            this.getAppLocale()
        )
    }

    private get lastSynchroStatus() {
        return this.synchDownHandler.getLastSyncStats()?.lastSynchroStatus ?? DataSynchronisationStatus.NONE;
    }

    private get isSyncing() {
        return this.synchDownHandler.isSyncing()
    }

    // not sure if usefull TODO test if it is really needed
    @Watch('isSyncing')
    private onSyncStateChange() {
        this.syncing = this.synchDownHandler.isSyncing();
        if (this.synchDownHandler.getLastSyncStats()?.lastSynchroStatus !== DataSynchronisationStatus.SUCCESS) {
            this.progressBarVariant = "danger";
        } else {
            this.progressBarVariant = "success";
        }
    }

}